import React from "react";

const JOURNEY_ITEMS = [
  {
    year: "2019",
    title: "Data Engineer – City National Bank",
    description:
      "Set up the Oracle BDA cluster and designed, built, deployed, and maintained end-to-end data pipelines on the Enterprise Data Lake.",
  },
  {
    year: "2020",
    title: "Coding for Kids – Community Impact",
    description:
      "Successfully conducted online 'Coding for Kids' classes during COVID, expanding into education and community impact.",
  },
  {
    year: "2021",
    title: "Kafka & Confluent Platform",
    description:
      "Deployed a secure Kafka Confluent Platform 7.1 cluster using Ansible automation and delivered data engineering solutions.",
  },
  {
    year: "2022",
    title: "CDH → CDP Upgrade with Cloudera",
    description:
      "Partnered with Cloudera to upgrade the platform from CDH 5.14.4 to CDP 7.1.7, improving data access for data science and engineering teams.",
  },
  {
    year: "2023",
    title: "Streaming Pipelines",
    description:
      "Implemented Kafka and Spark Streaming pipelines integrating S3, Spark, Kafka, and Solace source/sink connectors.",
  },
  {
    year: "2024",
    title: "Alvigor Web Application",
    description:
      "Built the Alvigor web application with Open APIs (Python, Flask, MySQL) using tools like Notion, Promod, and World Time.",
  },
  {
    year: "",
    title: "Multi-Vendor Digital Solutions",
    description:
      "Delivered WhatsApp Store, API integrations, and e-commerce solutions, and set up social media presence.",
  },
  {
    year: "",
    title: "Taftc Accounts RPA",
    description:
      "Implemented Accounts RPAs: ERP login, Ready-to-Payout, Email Sharing, and Disbursement to Marvel.",
  },
  {
    year: "2025",
    title: "Digital Consultant – Content",
    description:
      "Produced 100+ social media videos to build brand awareness and education.",
  },
  {
    year: "",
    title: "RPA Consultant – Accounts",
    description:
      "Deployed Accounts RPA in Tembusu Institute (Course Validation, Disburse Validation, Credit Note Validation).",
  },
  {
    year: "",
    title: "RPA Consultant – HR",
    description:
      "Implemented HR RPA in Tembusu Institute (Trainers’ Fee Calculation, Attendance Report, TRAQOM Survey Report).",
  },
  {
    year: "",
    title: "AI/Data Consultant – Cloudera Labs",
    description:
      "Set up AWS-based Cloudera clusters and labs: Admin, Data Engineering, Data Analyst, CAI, and CML labs.",
  },
  {
    year: "",
    title: "AI/Data Consultant – E-Learning",
    description:
      "Created an e-learning platform for the above Cloudera labs and content.",
  },
];

export default function JourneyTimeline() {
  return (
    <section className="timeline">
      <h2 className="timeline-heading">SiW Journey (2019–2025)</h2>
      <div className="timeline-list">
        {JOURNEY_ITEMS.map((item, index) => (
          <article className="timeline-item" key={`${item.year}-${index}`}>
            <div className="timeline-left">
              <span className="timeline-year">{item.year}</span>
              <span className="timeline-dot" />
              {index !== JOURNEY_ITEMS.length - 1 && (
                <span className="timeline-line" />
              )}
            </div>
            <div className="timeline-card">
              <h3 className="timeline-title">{item.title}</h3>
              <p className="timeline-description">{item.description}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
